import moment from 'moment'

export function formatDay(day: number): string {
  return day <= 9 ? `0${day}` : String(day)
}

export function formatMonth(month: number): string {
  return formatDay(month)
}

export function getValidPaymentDay(paymentDay: number | null): number {
  if (paymentDay) {
    if (paymentDay > 28)
      return 28

    if (paymentDay < 1)
      return 1

    return paymentDay
  }
  return 1
}

export function formatDateToString(date: Date, format: string = 'DD/MM/YYYY'): string {
  return moment(date).format(format)
}
